import { useState } from 'react';

export default function Teachers() {
  const [selectedTeacher, setSelectedTeacher] = useState(0);

  const teachers = [
    {
      id: 1,
      name: "羅老師",
      title: "語文競賽指導專家",
      experience: "15以上教學經驗",
      specialties: ["語文競賽指導", "競賽評審級專家", "趣味寫作指導", "教材研發撰寫"],
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/49545585d52c1e5a0e7460dbcb27f638.png",
      description: "羅老師擁有豐富的語文競賽指導經驗，本身也獲獎無數，長年專注於培養學生的語言表達能力和寫作技巧，並精心研發多元有趣的獨家主題式教材,深受學生和家長的喜愛。",
      achievements: [
        "指導學生獲獎無數",
        "持有合格教師證",
        "教育師範體系畢業",
        "語文競賽指導專家",
        "多本寫作教材出版"
      ],
      quote: "讀萬卷書，行萬里路，寫作就是記錄生命的精彩。"
    },
    {
      id: 2,
      name: "楊老師",
      title: "寫作指導專家",
      experience: "15以上教學經驗",
      specialties: ["創意寫作", "競賽指導", "趣味指導", "因材施教"],
      achievements: [
        "指導學生競賽得獎",
        "持有合格教師證",
        "教育師範體系畢業",
        "語文競賽指導專家",
        "多年教學經驗"
      ],
      description: "楊老師教學幽默風趣，專門從事寫作指導，擁有豐富的教學經驗，對於各種文體及寫作技巧都有深入研究，她能夠用多元有趣的方式教導寫作內容，讓學生在輕鬆的氛圍中提升寫作實力。",
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/0a27cd343e60e1ae5e82d2a2f41ea40b.jpeg",
      quote: "每個孩子都是天生的作家，只要給予鼓勵和引導。"
    },
    {
      id: 3,
      name: "陳老師",
      title: "文言文寫作專家",
      experience: "15以上教學經驗",
      specialties: ["文言文教學", "古典文學", "議論文寫作", "修辭技巧"],
      achievements: [
        "語文教學專家",
        "文言文與成語教材撰寫",
        "持有合格教師證",
        "教育師範體系畢業",
        "多年教學經驗"
      ],
      description: "陳老師是文言文及古典文學的專家，擁有專業學術背景。她能夠深入淺出的講解文言文語意，認真的態度也讓學生在理解古典文學之美的同時，提升現代寫作能力。",
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/f4dd58d9ce2dd031a6aeb9f954ebbc67.png",
      quote: "學習沒有捷徑，唯有勤奮與堅持才能成就夢想。"
    },
    {
      id: 4,
      name: "林老師",
      title: "專業寫作指導師",
      experience: "10年以上教學經驗",
      specialties: ["基礎寫作", "看圖寫作", "口述作文", "語文競賽"],
      achievements: [
        "教育大學語文教育系畢業",
        "擁有合格教師證",
        "10年以上教學經驗",
        "專業寫作指導老師"
      ],
      description: "林老師是語文競賽多年選手出身的指導老師，尤其擅長活潑有趣的的教學，親切溫和的風格深受同學的喜愛，能夠耐心引導每個孩子進入語文殿堂。",
      image: "https://static.readdy.ai/image/6a4168e1db81f7a7fb40133af0c991e9/a738fac2261f14ce8e9a958c7f4f7ca1.png",
      quote: "用愛心陪伴，用耐心引導，讓每個孩子都能愛上寫作。"
    }
  ];

  const teachingPhilosophy = [
    {
      icon: "ri-heart-line",
      title: "因材施教",
      description: "每個學生都是獨特的個體，我們會根據學生的特質和需求，量身打造最適合的教學方式。"
    },
    {
      icon: "ri-lightbulb-line",
      title: "啟發創意",
      description: "我們相信每個孩子都有無限的創意潛能，透過適當的引導和鼓勵，讓創意自然流露。"
    },
    {
      icon: "ri-graduation-cap-line",
      title: "專業教學",
      description: "所有教師都具備15年以上教學經驗和教師證，確保教學品質和學習效果。"
    },
    {
      icon: "ri-team-line",
      title: "互動學習",
      description: "營造輕鬆愉快的學習氛圍，鼓勵學生積極參與，在互動中提升寫作能力。"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-pink-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-pink-500" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">首頁</a>
                <a href="/courses" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">課程介紹</a>
                <a href="/teachers" className="text-pink-500 font-medium px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer">師資團隊</a>
                <a href="/results" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">教學成果</a>
                <a href="/trial" className="text-gray-700 hover:text-pink-500 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer">免費試聽</a>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-gray-700 hover:text-pink-500 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-pink-50 to-rose-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            專業師資團隊
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            我們擁有最優秀的教師團隊，每位老師都具備15以上教學經驗和教師證，
            致力於為學生提供最優質的寫作教育
          </p>
        </div>
      </section>

      {/* Featured Teacher */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative">
              <img
                src={teachers[selectedTeacher].image}
                alt={teachers[selectedTeacher].name}
                className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover object-top"
              />
              <div className="absolute -bottom-6 -right-6 bg-pink-500 text-white p-6 rounded-xl shadow-lg">
                <div className="text-center">
                  <p className="text-2xl font-bold">{teachers[selectedTeacher].experience}</p>
                  <p className="text-pink-100">教學經驗</p>
                </div>
              </div>
            </div>
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                {teachers[selectedTeacher].name}
              </h2>
              <p className="text-xl text-pink-500 mb-6">{teachers[selectedTeacher].title}</p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                {teachers[selectedTeacher].description}
              </p>

              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">專長領域</h3>
                <div className="grid grid-cols-2 gap-3">
                  {teachers[selectedTeacher].specialties.map((specialty, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-check-line text-pink-500"></i>
                      <span className="text-gray-600">{specialty}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">教學成就</h3>
                <div className="space-y-2">
                  {teachers[selectedTeacher].achievements.map((achievement, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-award-line text-pink-500"></i>
                      <span className="text-gray-600">{achievement}</span>
                    </div>
                  ))}
                </div>
              </div>

              {teachers[selectedTeacher].quote && (
                <blockquote className="border-l-4 border-pink-500 pl-6 italic text-gray-700 text-lg">
                  "{teachers[selectedTeacher].quote}"
                </blockquote>
              )}
            </div>
          </div>

          {/* Teacher Selection */}
          <div className="grid md:grid-cols-4 gap-6">
            {teachers.map((teacher, index) => (
              <div
                key={teacher.id}
                onClick={() => setSelectedTeacher(index)}
                className={`p-6 rounded-xl cursor-pointer transition-all ${
                  selectedTeacher === index
                    ? 'bg-pink-500 text-white shadow-lg'
                    : 'bg-pink-50 hover:bg-pink-100'
                }`}
              >
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-4">
                    <img
                      src={teacher.image}
                      alt={teacher.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <h3 className="font-bold mb-2">{teacher.name}</h3>
                  <p className={`text-sm ${selectedTeacher === index ? 'text-pink-100' : 'text-gray-600'}`}>
                    {teacher.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teaching Philosophy */}
      <section className="py-20 bg-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              教學理念
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們的教學團隊秉持著共同的教育理念，致力於為每位學生提供最優質的學習體驗
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teachingPhilosophy.map((philosophy, index) => (
              <div key={index} className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${philosophy.icon} text-2xl text-pink-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{philosophy.title}</h3>
                <p className="text-gray-600 leading-relaxed">{philosophy.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Teacher Qualifications */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              師資標準
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我們對教師有嚴格的篩選標準，確保每位老師都能提供最專業的教學服務
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">學歷要求</h3>
              <p className="text-gray-600 leading-relaxed">
                正統師範及教育大學語文系畢業，具備卓越的國語教學能力
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">經驗要求</h3>
              <p className="text-gray-600 leading-relaxed">
                15年以上教學經驗，熟悉各年齡層學生的學習特點
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-fill text-3xl text-pink-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">教師證書</h3>
              <p className="text-gray-600 leading-relaxed">
                持有合格教師證，對教育充滿熱忱，能夠耐心引導學生
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-pink-500 to-rose-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            想要體驗我們的專業教學嗎？
          </h2>
          <p className="text-xl text-pink-100 mb-8 max-w-2xl mx-auto">
            立即預約免費試聽課程，親自感受我們優秀教師團隊的教學魅力
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-pink-500 px-8 py-4 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
              立即免費試聽
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-pink-500 transition-colors whitespace-nowrap cursor-pointer">
              師資諮詢
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 text-pink-400" style={{fontFamily: '"Pacifico", serif'}}>
                共學趣線上國語文寫作教室
              </h3>
              <p className="text-gray-400 mb-6 leading-relaxed">
                專業線上寫作教室，致力於培養孩子的寫作能力與創意思維。
                我們相信每個孩子都有無限潛能，只需要正確的引導。
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-line-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速連結</h4>
              <ul className="space-y-2">
                <li><a href="/courses" className="text-gray-400 hover:text-white transition-colors cursor-pointer">課程介紹</a></li>
                <li><a href="/teachers" className="text-gray-400 hover:text-white transition-colors cursor-pointer">師資團隊</a></li>
                <li><a href="/results" className="text-gray-400 hover:text-white transition-colors cursor-pointer">教學成果</a></li>
                <li><a href="/trial" className="text-gray-400 hover:text-white transition-colors cursor-pointer">免費試聽</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-line-fill"></i>
                  <span>@write123</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-fill"></i>
                  <span>週一至週日 9:0 0-21:0 0</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-fill"></i>
                  <span>線上教學，不限地區</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 共學趣線上寫作教室. All rights reserved. |
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer ml-2">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
